import React, {Component} from 'react';
//import { plainToClass } from 'class-transformer';
import 'reflect-metadata';
import {fetchJwtToken} from '../utils';
//import { Definition } from '../data/Definition';
import DwQueryClient from '../data/DwQueryClient';
import { /*IDwFilter,*/ IDwGeoFilter, DwQuery, IDwFilterWarapper, IDwCrossFilter } from '../data/Query';
import {Tile as TileLayer} from 'ol/layer.js';
import VectorTileLayer from 'ol/layer/VectorTile';
import WebGLTileLayer from 'ol/layer/WebGLTile';
import { Modal, Form, Tabs, Tab, Button} from 'react-bootstrap';
import Dropdown, {
  DropdownToggle,
  DropdownMenu,
  /*DropdownMenuWrapper,*/
  MenuItem,
  /*DropdownButton*/
} from '@trendmicro/react-dropdown';
import ApolloClient from 'apollo-boost';
// import gql from 'graphql-tag';
import {unByKey} from 'ol/Observable';
import ReactDOM from "react-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faBars } from "@fortawesome/free-solid-svg-icons";
import {initMap, createMapObject, initDataWarehouseLayer, initServiceLayer } from "./mapInit";
import MapLayers from "./MapLayers";
import '../styles/Map.scss';
import '@fortawesome/fontawesome-free/js/all.js';
import '@trendmicro/react-buttons/dist/react-buttons.css';
import '@trendmicro/react-dropdown/dist/react-dropdown.css';
import MapDwForm from './maps/MapDwForm';
import MapServiceLayerForm from './maps/MapServiceLayerForm';
import MapRenameDwLayer from './maps/MapRenameDwLayer';
import MapStyleDwLayer from './maps/MapStyleDwLayer';
import QueryProvider from './charts/QueryProvider';
import { getDataDefinitions, isStats } from '../data/utils';
import WebGLPointsLayer from 'ol/layer/WebGLPoints.js';
import { SocketContext } from '../context/socket';
import { DwMapLayerConfigManager } from './DwMapLayerConfigManager';
import { colorStyleToWebGlStyle } from '../colorscaleUtils';
import VectorSource from 'ol/source/Vector';
// import moment from 'moment';
import { ALL_LAYERS_QUERY } from '../queries';
// side load the definition for now.
// 
//let loadJson = require('../load.json');

// expr, jq, color_map, color_ramp, global_min and global_max
/*
class CustomToggle extends Component<any, any> {
  constructor(props: any, context: any) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: any) {
    e.preventDefault();

    this.props.onClick(e);
  }

  render() {
    return (
      // eslint-disable-next-line
      <a href="" onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }
}
*/

class DashboardMapWidget extends Component<any, any> {
  private childrefMapWidget: any;
  private childRefDwStyle: any;
  private childRefMapServiceConfig: any;
  constructor(props: any) {
    super(props);
    this.state = {
      showModal: false,
      activeModal: "",
      menuExpanded: true,
      layers: [],
      availableLayers: [],
      swipeValue: 0,
      definitionWrappers: [],
      selectedDefinitionWrapper: null,
      //definition:[],
      presentLayerStyle: {highRenderedColor: "#f44336", strokeColor: "#ffffff", configOrigin: "mapWidget constructor a", maxVal: null, minVal: null},
      availableLayerServices: [],
      availableLayerStyles: {},
      selectedLayerService: null,
      selectedLayerServiceObject: null,
      showHoverButtons: false,
    }

    this.socket = undefined!;

    this.handleLayerNameChange = this.handleLayerNameChange.bind(this);
    this.handleFormChangeInput = this.handleFormChangeInput.bind(this);

    this.handleServiceLayerNameChange = this.handleServiceLayerNameChange.bind(this);
    this.handleServiceFormChangeInput = this.handleServiceFormChangeInput.bind(this);

    this.handleChangeColor = this.handleChangeColor.bind(this);
    this.handleSaveColor = this.handleSaveColor.bind(this);

    this.sessionId = props.sessionId as string;
    
    this.configUpdated = this.configUpdated.bind(this);
    this.serviceConfigUpdated = this.serviceConfigUpdated.bind(this);
    this.layerStyleUpdated = this.layerStyleUpdated.bind(this);
    this.childrefMapWidget = React.createRef();
    this.childRefDwStyle = React.createRef();
    this.childRefMapServiceConfig = React.createRef();
  }
  
  private serverUrl = process.env.REACT_APP_CHATBOT_URL as string;
  private sessionId: string;
  private socket: SocketIOClient.Socket;
  private geoFilter : IDwGeoFilter | null = null;
  private geoFilterMultiPolygon : IDwGeoFilter | null = null;
  private crossFilters: IDwCrossFilter[] = [];

  static contextType = SocketContext;
  context!: React.ContextType<typeof SocketContext>;

  private map: any;

  private swipePrecomposeKey: any;
  private swipePostcomposeKey: any;
  private apolloClient: any = null;

  private presentLayerName: string = "Data Warehouse";
  private presentServiceLayerName: string = "Service Layer";
  private presentLayerHighColor: string = "#F90710";
  private presentLayerLowColor: string = "#F90710"; // "#2807F9";  
  private presentLayerHighPoint: any = 8;
  private presentLayerLowPoint: any = 8;
  private presentLayerMaxVal: any = null;
  private presentLayerMinVal: any = null;

  async initialLoad() {    
      // 
      // get all the definitions registered for this org.
      //
      const definitionWrappers = await getDataDefinitions(this.apolloClient);
      console.log("definitionWrappers", definitionWrappers);

      this.setState({ 
        definitionWrappers
      });

      console.log("REACT_APP_COGNITO_DOMAIN", process.env.REACT_APP_COGNITO_DOMAIN)
  }

  async loadDwLayer(msg: any, layerTitle:any, layerVisibility:boolean, layerStyle:any = false, updateOnly:boolean = false, layerToUpdate: any = null) {
      console.log('loadDwLayer > msg', msg);
      console.log('loadDwLayer > layerVisibility', layerVisibility);
      console.log('loadDwLayer > layerTitle', layerTitle);
      console.log('loadDwLayer > layerStyle', layerStyle);
      console.log("loadDwLayer > queryConfig", msg.queryConfig);
      console.log('loadDwLayer > updateOnly', updateOnly);
      console.log('loadDwLayer > layerToUpdate', layerToUpdate);
    
      let queryConfig = {...msg.queryConfig};

      if(queryConfig === undefined) {
        return;
      }
            
      if(queryConfig.measure){
        if ((queryConfig.measure.source.item.type !== "number")&&(queryConfig.measure.source.item.type !== "integer")){
          queryConfig.measure["aggregation"] = "avg";
        }else{
          delete queryConfig.measure["aggregation"];
        }
      }
      
      console.log('queryConfig', queryConfig );
      
      const defWarapper = this.state.definitionWrappers.find((d:any) => d.id === queryConfig.definitionId);
      if(!defWarapper) {
          return;
      }
      console.log('defWarapper', defWarapper);
      let layerCitation = defWarapper.citation;
      // validate query configuration.
      const configManager = new DwMapLayerConfigManager(defWarapper.definition);
      if(!configManager.isCurrentVersion(queryConfig)) {
        console.log('DW map layer > before converting chart config', queryConfig);
        queryConfig = configManager.convert(queryConfig);
        console.log('DW map layer > after converting chart config', queryConfig);
      }

      if(!configManager.validate(queryConfig)) {
        console.log('DW map layer > configuration not valid', queryConfig);
        return;
      }

      // given the query config, convert to a query.
      const provider = new QueryProvider();
      
      let query = provider.getQuery(defWarapper.definition, queryConfig);
      
      console.log("122221 BEFORE queryConfig,", queryConfig);
      console.log("query,", query);
      if (query){
        if (query.feature === 'multipolygon'){
          console.log('query', query);
          if (query.dimensions){ 
            console.log('query.dimension', query.dimensions );
            if (query.dimensions[0]){
              query.dimensions[0]["name"] = "";
            }
          }
        }
      }
      console.log("query string,", JSON.stringify(query));
      console.log("query,", query);
      
      if(!query) {
          return;
      }

      if(!layerStyle) {
        if (msg.layerStyle){
          layerStyle = msg.layerStyle
          console.log("layerStyle", layerStyle)
          layerStyle.maxVal = this.presentLayerMaxVal
          layerStyle.minVal = this.presentLayerMinVal
        }else{
          console.log("THERE WAS NO layerStyle IN MESSAGE SO SETTING STYLE TO DEFAULT")
          layerStyle = {highRenderedColor: this.presentLayerHighColor, lowRenderedColor: this.presentLayerLowColor, highRenderedPoint: this.presentLayerHighPoint, lowRenderedPoint: this.presentLayerLowPoint, strokeColor: "#ffffff", configOrigin: "mapWidget constructor b", maxVal: this.presentLayerMaxVal, minVal: this.presentLayerMinVal} //this.state.presentLayerStyle
        }
     }

      // apply cross filters and update id of spatial filter based on the layer configuration.
     this.prepareFilters(query);

      // query the api for the data
      try {
        let data = await this.queryData(query, "map");
        console.log('GeoJSON got data from query', query);
        console.log('GeoJSON string query', JSON.stringify(query));
        console.log('GeoJSON data', data);
        console.log('updateOnly', updateOnly);
        //if (data.features[0].geometry.type === 'Point'){ // DW points must be rendered with WebGL layer
        if (queryConfig.feature !== 'multipolygon'){ // DW points must be rendered with WebGL layer
          //console.log("layerStyle", layerStyle)
          if (updateOnly){
            console.log("GeoJSON - Updating existing layer, layerToUpdate", layerToUpdate)
            initDataWarehouseLayer(
              this.map,
              data,
              layerTitle,
              queryConfig,
              layerStyle,
              msg.chartType,
              layerToUpdate,
              query,
              "point",
              layerCitation, 
              layerVisibility
            );
          }else{
            console.log("GeoJSON - Creating new DW layer")
            initDataWarehouseLayer(
              this.map,
              data,
              layerTitle,
              queryConfig,
              layerStyle,
              msg.chartType,
              null,
              query,
              "point",
              layerCitation,
              layerVisibility
            );
          }
        }else{  // Render polygons with GeoJSON layer
          console.log('Handling a GeoJSON poly layer...');
          console.log('field GeoJSON data',data);

          let statMetric = '';
          if(queryConfig.measure && queryConfig.measure.source.item) {
            if(isStats(queryConfig.measure.source.item)) {
              statMetric = `${queryConfig.measure.source.item!.property}_${queryConfig.measure.source.sub}`;

            } else {
              statMetric = `${queryConfig.measure.source.item!.name}_${queryConfig.measure.aggregation}`;
            }
          }

          console.log('020222 statMetric', statMetric);
          console.log('020222 defWarapper', defWarapper);
          console.log('020222 queryConfig', queryConfig);

          let joinedObject = this.summarizeData({...data}, 'field_id', 'id', statMetric, queryConfig, defWarapper); 
          let joinedData = joinedObject.geo_data; 

          console.log('011022 field data joinedData', joinedData);
          console.log('011022 field data updateOnly', updateOnly);
          console.log('layerStyle', layerStyle);
          layerStyle["minValue"] = joinedObject.minValue;
          layerStyle["maxValue"] = joinedObject.maxValue; 
          if (updateOnly){
            console.log("GeoJSON - Updating existing layer, layerToUpdate", layerToUpdate)
            initDataWarehouseLayer(
              this.map,
              joinedData,
              layerTitle,
              queryConfig,
              layerStyle,
              msg.chartType,
              layerToUpdate,
              query,
              "GeoJSON",
              layerCitation,
              layerVisibility
            );
          }else{
            initDataWarehouseLayer(
              this.map,
              joinedData,
              layerTitle,
              queryConfig,
              layerStyle,
              msg.chartType,
              null,
              query,
              "GeoJSON",
              layerCitation,
              layerVisibility
            );
          }
        };
    } catch(err) {
        console.error(err);
    }
  }

  dedupeData(_data: any, fieldId: string, altFieldId: string) {
    const array = _data.features;
    const result = [];
    const map = new Map();
    for (const item of array) {
      if(item.properties.hasOwnProperty(fieldId)){
        if(!map.has(item.properties[fieldId])){
          map.set(item.properties[fieldId], true);
          result.push(
              item
          );
        }
      }else if(item.properties.hasOwnProperty(altFieldId)){
        if(!map.has(item.properties[altFieldId])){
          map.set(item.properties[altFieldId], true);
          result.push(
              item
          );
        }
      }
    }
    console.log(result)
    _data.features = result;
    return _data;
  }

  summarizeData(geo_data: any, fieldId: string, altFieldId: string, valueFieldName: string, queryConfig:any, defWarapper:any ) {
    console.log("Summarizing data:")
    console.log("geo_data", geo_data)
    var minValue: number = 1000000;
    var maxValue = -1000000;
    if (geo_data.features){
      geo_data.features.forEach((item: any) => {
        const value = item.properties[valueFieldName];
        minValue = Math.min(value, minValue); // Hard-code MIN DW Poly
        maxValue = Math.max(value, maxValue); // Hard-code MAX DW Poly
      });
    }else{
      minValue = 0;
      maxValue = 0;
    }
    console.log("030322 queryConfig", queryConfig)
    if (queryConfig.measure.source.item.max && queryConfig.measure.source.item.min){
      minValue = queryConfig.measure.source.item.min;
      maxValue = queryConfig.measure.source.item.max;
    }else {
      console.log("020222 defWarapper", defWarapper);
      if (defWarapper.definition.property.length > 0 ){
        console.log("020222 defWarapper.definition.property", defWarapper.definition.property);
        defWarapper.definition.property.forEach((p: any) => {
          console.log("020222 p", p);
          console.log("030322  queryConfig.measure.source.item.property", queryConfig.measure.source.item.property);
          if (p.property === queryConfig.measure.source.item.property){
            if ( p.min && p.max){
              console.log("030322 p.min, p.max", p.min, p.max);
              minValue = p.min;
              maxValue = p.max;
            }
          }
        })
      }
    }
    console.log("Joined data minValue, maxValue", minValue, maxValue );
    return {geo_data, minValue, maxValue};
  }

  async loadServiceLayer(msg: any, layerTitle:any, layerVisibility:boolean) {
    console.log('loadServiceLayer > msg', msg);
    console.log('loadServiceLayer > layerVisibility', layerVisibility);
    console.log('loadServiceLayer > layerTitle', layerTitle);
    console.log("loadServiceLayer > serviceConfig", msg.serviceConfig);
  
    let serviceConfig = msg.serviceConfig;

    if(serviceConfig === undefined) {
      return;
    }

    let layerStyle;
    if (msg.layerStyle){
      layerStyle = msg.layerStyle
    }else{
      console.log("THERE WAS NO layerStyle IN MESSAGE SO SETTING STYLE TO DEFAULT")
      layerStyle = null; 
    }
    

    initServiceLayer(
      this.map,
      layerTitle,
      serviceConfig,
      layerStyle,
      msg.chartType,
      null,
      layerVisibility
    );
  }
  

  prepareFilters(query: DwQuery) {
    // Get all the filters from other widgets. The only filter the map will supply is the 
    // aoi filter. while this could be in the list, we filter it out because we need to
    // modify id path for the specific layer.
    //
    const xfilters = this.crossFilters.filter((filter: IDwCrossFilter) => {
        const sameWidget = filter.widgetInstanceId === this.props.widgetInstance.id;
        const sameDefinition = filter.definitionId === query.definitionId;

        return !sameWidget && sameDefinition;
    });

    // update the query to include the selected cross filters.
    //
    const queryFilters = xfilters.map((item:any) => item.filter);
    query.filters.push(...queryFilters);    

    // apply geo filter if set.
    //
    console.log("A012122 this.geoFilter query", query);
    console.log("A012122 this.geoFilter", this.geoFilter);
    console.log("A012122 this.geoFilterMultiPolygon", this.geoFilterMultiPolygon);
    if (query.feature === "multipolygon"){
      console.log("A012122 this.geoFilterMultiPolygon", this.geoFilterMultiPolygon);
      if(this.geoFilterMultiPolygon !== null) {
        this.geoFilterMultiPolygon.id = `${query.entity}:${query.entity}`;
        query.filters.push(this.geoFilterMultiPolygon);
      }
    }else{
      if(this.geoFilter !== null) {
        if(query.dimensions.length > 0) {
          this.geoFilter.id = query.dimensions[0].id;
        } else {
          this.geoFilter.id = query.entity;
        }

        query.filters.push(this.geoFilter);
      }
    }
    console.log("FINAL query,", query)
    console.log("FINAL query string,", JSON.stringify(query))
  }

  publishFilters(filters: IDwFilterWarapper[]) {
    this.socket.emit('chart', {
        command: 'filterChange',
        filters: filters,
        widgetInstanceId: this.props.widgetInstance.id,
        widgetInstanceTitle: this.props.widgetInstance.title
    });
  }

  updateAOIQuery(aoiMSG: any){
    console.log("updateAOIQuery(aoiMSG", aoiMSG);
    // After an alteration to the AOI, two main steps will happen:
    //    #1 publish AOI as new filter 
    //    #2 update any DW layers according to new (AOI) geoFilter
    //    ...By Following this pipeline:
    //          mapWidget.tsx/publishFilters() > to ChatBot > to Filters.tsx > (back) to mapWidget.tsx/updateDWlayers()
    //
    // #1 Prep and publish the new AOI as a filter to the filter manager
    //

    // remove filter if no aoi, otherwise add/update.
    //
    if (this.map.aoi_bbox){
      let aX = this.map.aoi_bbox[0];
      let bX = this.map.aoi_bbox[1];
      let dX = this.map.aoi_bbox[2];
      let cX = this.map.aoi_bbox[3];

      var extent_AOI = [
        [aX, bX], 
        [aX, cX], 
        [dX, cX], 
        [dX, bX], 
        [aX, bX]
      ];

      console.log("Updating AOI to extent_AOI ", extent_AOI)
      console.log("Updating AOI this ", this)

      this.geoFilter = {
        type:"geojson",
        operation: "within",
        id: "_",
        name: "",
        feature: "point",
        value:{
          type: "MultiPolygon",
          coordinates: [[extent_AOI]]
        }, 
        widgetInstanceId: this.props.widgetInstance.id,
        widgetInstanceTitle: this.props.widgetInstance.title
      };

      this.geoFilterMultiPolygon = {
        type:"geojson",
        operation: "within",
        id: "_",
        name: "",
        feature: "multipolygon",
        value:{
          type: "MultiPolygon",
          coordinates: [[extent_AOI]]
        }, 
        widgetInstanceId: this.props.widgetInstance.id,
        widgetInstanceTitle: this.props.widgetInstance.title
      };
    } else {
      this.geoFilter = null;
      this.geoFilterMultiPolygon = null;
    }

    // empty array removes the filter.
    //
    this.publishFilters(this.geoFilter !== null ? [{
        definitionId: -1,
        filter: this.geoFilter, 
        bySelection: false
      }] : []);
  }

  updateDwLayers() { 
    console.log("updateDwLayers()")
    // The filter changed so make adjustments to DW layers accordingly
    //console.log("this.map,", this.map)
    console.log("this.map['layerList'],", this.map["layerList"])
    console.log("this.map.getLayers().getArray(),", this.map.getLayers().getArray())
    console.log("this.state.layers,", this.state.layers)
    console.log("this.map['originalLayerOrder'] BEFORE,", this.map.originalLayerOrder)
    this.map["originalLayerOrder"] = [];
    this.map.getLayers().getArray().forEach((layer: any) => {
      let layerT = layer.get('title');
      console.log("layer", layer)
      console.log("layerT", layerT)
      if (layerT){
        if (!["Statistics", "Basemap"].includes(layerT)){
          console.log("this.map.originalLayerOrder.push(layer)", layer)
          this.map.originalLayerOrder.push(layer);
        }
      }
    })
    console.log("_082021A this.map['originalLayerOrder'] AFTER,", this.map.originalLayerOrder)
    this.map.originalLayerOrder.sort(function(a:any, b:any){
      return b.get('zIndex') - a.get('zIndex');
    });
    console.log("_082021A this.map['originalLayerOrder'] AFTER SORT,", this.map.originalLayerOrder)
    console.log("_082021A this.map['layerListOnLoad'],", this.map["layerListOnLoad"])

    //this.map["originalLayerOrder"] = this.map.layerList;
    this.map.getLayers().getArray().forEach((layer: any) => {
      // DW layers contain dwdataQueryConfig property
      if (layer.hasOwnProperty('dwdataQueryConfig')){ 
        console.log("DW layer encountered --> layer = ", layer);
        console.log("layer > layerDefID?", layer)
        let existngDWParams = {
          chartType: 'dwLayer',// layer["dwdataChartType"],
          layerDefID: layer.dwdataQueryConfig.definitionId,
          queryConfig: layer['dwdataQueryConfig'],
          layerStyle: layer['dwdataLayerStyle'],
          widgetInstanceId: this.props.widgetInstance.id,
          widgetInstanceTitle: this.props.widgetInstance.title,
        }
        // Last two parameters indicate this is a DW layer update and will prevent new layer from being created
        console.log("layer ", layer);
        
        this.loadDwLayer(existngDWParams, layer.get('title'), layer.visible, layer['dwdataLayerStyle'], true, layer); 
      }else{
        console.log("tile layer encountered --> layer = ", layer);
      }
    });
    console.log("DONE UPDATING... this.map['originalLayerOrder']", this.map["originalLayerOrder"])
  }

  async queryData(query: DwQuery, caller:string) {
      console.log("this.map.aoi_bbox", this.map.aoi_bbox);
      console.log("query,", query);

      const api = new DwQueryClient(process.env.REACT_APP_CHATBOT_URL!);

      try {
          return await api.doQuery(query,caller);
      } catch(e) {
          console.error(e);
      }

      return null;
  }
  
  handleLayerOrderChange(newOrder: any, doEmit: boolean = false) {
    console.log('handleLayerOrderChange newOrder, doEmit', newOrder, doEmit);
    console.log('handleLayerOrderChange this.map.getLayers()',this.map.getLayers());

    // first build up mapping between layer titles and layer objects for efficient lookup
    const layerTitleMapping: any = {};
    this.map.getLayers().getArray().forEach((layer: any) => {
      //console.log('handleLayerOrderChange() > layer', layer);
      const layerTitle = layer.get('title');
      if (layerTitle) {
        layerTitleMapping[layerTitle] = layer;
      }
    });
    console.log('handleLayerOrderChange layerTitleMapping',layerTitleMapping);
    // now set zIndex of each layer according to order from websockets event
    // and rebuild layers state array so list renders in updated order
    const layers: any = [];
    newOrder.forEach((layerName: string, i: number) => {
      const layer = layerTitleMapping[layerName];
      if (layer) {
        if (layer.getLayers) {
          layer.getLayers().forEach((layerChild: any) => {
            layerChild.setZIndex(50-i);
          });
        } else {
          layer.setZIndex(50-i);
        }
        layers.push(layer);
      }
    });

    // layer at top of list gets swipe enabled
    if (layers.length > 0) {
      this.enableSwipeOnLayer(layers[0]);
    }
    console.log("layers", layers)
    this.setState({
      layers,
    }, () => {
      if (doEmit) {
        this.emitLayerList('layerOrderChange', null,null,null,"handleLayerOrderChange");
      }
    });
    /*const mapLayerTitleMapping: any = {};
    console.log("this.map.layerList", this.map.layerList)
    for (var i = 0; i < this.map.layerList.length; i++) {
      mapLayerTitleMapping[this.map.layerList[i].title] = this.map.layerList[i]
    } 
    const mapLayers: any = [];
    for (var j = 0; j < layers.length; j++) {
      mapLayers.push(mapLayerTitleMapping[layers[j].title])
    }
    this.map["layerList"] = mapLayers*/
  }

  handleLayerStyleChange(newOrder: any, doEmit: boolean = false, _layer: any = null) {
    console.log('handleLayerStyleChange newOrder, doEmit', newOrder, doEmit);

    // first build up mapping between layer titles and layer objects for efficient lookup
    const layerTitleMapping: any = {};
    this.map.getLayers().getArray().forEach((layer: any) => {
      console.log('layer', layer);
      //console.log("layer.get('title')", layer.get('title'));

      const layerTitle = layer.get('title');
      if (layerTitle) {
        layerTitleMapping[layerTitle] = layer;
      }
    });

    // now set zIndex of each layer according to order from websockets event
    // and rebuild layers state array so list renders in updated order
    const layers: any = [];
    newOrder.forEach((layerName: string, i: number) => {
      const layer = layerTitleMapping[layerName];
      if (layer) {
        if (layer.getLayers) {
          layer.getLayers().forEach((layerChild: any) => {
            //console.log("Layer-DEV layer", layer)
            //console.log("Layer-DEV z-index", 50-i)
            layerChild.setZIndex(50-i);
          });
        } else {
          layer.setZIndex(50-i);
        }
        layers.push(layer);
      }
    });

    // layer at top of list gets swipe enabled
    if (layers.length > 0) {
      this.enableSwipeOnLayer(layers[0]);
    }
    //console.log("Layer-DEV layers", layers)
    this.setState({
      layers,
    }, () => {
      if (doEmit) {
        this.emitLayerList('layerStyleChange',null,null,_layer,"handleLayerStyleChange");
      }
    });
  }

  // following https://openlayers.org/en/v5.3.0/examples/layer-swipe.html
  enableSwipeOnLayer(layer: any) {
    if (layer instanceof TileLayer) {
      if (this.swipePrecomposeKey) {
        unByKey(this.swipePrecomposeKey);
      }
      if (this.swipePostcomposeKey) {
        unByKey(this.swipePostcomposeKey);
      }

      // note these events change to prerender/postrender in OpenLayers 6 example
      //this.swipePrecomposeKey = layer.on('precompose', (evt: any) => {
      this.swipePrecomposeKey = layer.on('prerender', (evt: any) => {
        const ctx = evt.context;
        const width = ctx.canvas.width * (parseFloat(this.state.swipeValue) / 100);

        ctx.save();
        ctx.beginPath();
        ctx.rect(width, 0, ctx.canvas.width - width, ctx.canvas.height);
        ctx.clip();
      });

      //this.swipePostcomposeKey = layer.on('postcompose', (evt: any) => {
      this.swipePostcomposeKey = layer.on('postrender', (evt: any) => {
        // restore the canvas drawing state (just following the example here)
        const ctx = evt.context;
        ctx.restore();
      });
    }
  }
  
  handleLayerAddRemoveDataWarehouse(layerMSG: any, layerTitle: any, layerStyle: any) {
    console.log("handleLayerAddRemoveDataWarehouse() > layerMSG ", layerMSG)
    console.log("handleLayerAddRemoveDataWarehouse() > layerTitle ", layerTitle)
    console.log("handleLayerAddRemoveDataWarehouse() > layerStyle ", layerStyle)
    this.loadDwLayer(layerMSG.layerParams, layerTitle, layerMSG.visible, layerStyle);
  }

  handleLayerAddRemoveService(layerMSG: any, serviceLayerTitle: any, layerStyle: any) {
    console.log("handleLayerAddRemoveService() > layerMSG ", layerMSG)
    console.log("handleLayerAddRemoveService() > serviceLayerTitle ", serviceLayerTitle)
    this.loadServiceLayer(layerMSG.layerParams, serviceLayerTitle, layerMSG.visible);
  }

  handleLayerAddRemove(layer: any, deleted = false, onPageLoadContext = false, caller:any = "unknown") {
    console.log("handleLayerAddRemove() > layer, deleted, onPageLoadContext, caller", layer, deleted, onPageLoadContext, caller)
    console.log("this.state.layers BEFORE STATE CHANGE", this.state.layers);
    this.setState((state: any) => {
      //console.log("", [...state.layers].filter((l: any) => l.get('title') === "Parcel Search"));
      let layers: any[];
      if (deleted) {
        console.log("Deleting a layer:", layer)
        layers = [...state.layers].filter((l: any) => l.get('title') !== layer.get('title'));
      } else {
        console.log("Adding a layer:", layer)
        if (onPageLoadContext){ // Upon pageload, layers must be added to bottom (as per the order in which they are stored). 
          console.log(" ... to BOTTOM")
          layers = [...this.state.layers, layer];
        }else{ // Add new layers to the top of the layer list 
          console.log(" ... to TOP")
          layers = [layer, ...this.state.layers];
        }
      }
      //console.log("this.state.layers middle", this.state.layers);
      //console.log("layers middle", layers);
      if (layers.length > 0) {
        this.enableSwipeOnLayer(layers[0]);
      }

      // make sure z-indexes are set according to order in list
      layers.forEach((layer: any, i: number) => {
        if (layer.getLayers) {
          layer.getLayers().forEach((layerChild: any) => {
            layerChild.setZIndex(50-i);
          });
        } else {
          layer.setZIndex(50-i);
        }
      });
      
      
      console.log("layers:", layers)
      console.log("this.map:", this.map)
      console.log("state.layers", this.state.layers);
      //this.map["layerList"] = layers; //this.state.layers;
      //this.emitLayerList('layerChange');
      //this.emitLayerList('layerStyleChange',null,null,layer);
      //this.emitLayerList('layerOrderChange');
      return {
        layers,
      }
    });
    //console.log("Layer-DEV *******************************************************");
    //console.log("Layer-DEV this.state.layers AFTER STATE CHANGE", this.state.layers);
    //console.log("Layer-DEV this.map[layerList] AFTER STATE CHANGE", this.map["layerList"]);
    //console.log("Layer-DEV this.map[layerListOnLoad] AFTER STATE CHANGE", this.map["layerListOnLoad"]);
    //console.log("Layer-DEV this.map[originalLayerOrder] AFTER STATE CHANGE", this.map["originalLayerOrder"]);
    //console.log("Layer-DEV onPageLoadContext", onPageLoadContext);
    //console.log("Layer-DEV deleted", deleted);
    //console.log("Layer-DEV layer", layer);
    //console.log("Layer-DEV *******************************************************");
    if (!this.map.originalLayerOrder){
      this.map["originalLayerOrder"] = [];
    }
    /*for (const mL of this.map.originalLayerOrder) {
      //console.log("Layer-DEV originalLayerOrder > ", mL.get('title'));
    } */

    //this.map["layerList"] = this.state.layers;
    //this.state.layers = this.map["layerList"]
    var passLayer = false;
    if (!onPageLoadContext && !deleted && (this.map.originalLayerOrder.length > 0)&& (this.state.layers.length === this.map.originalLayerOrder.length)){
    //  passLayer = layer;
      let reStateLayers:any = [];
      this.map.originalLayerOrder.forEach((layerT: any) => {
        this.state.layers.forEach((layer_statelayers: any) => {
          //console.log("layerT", layerT);
          let layerTTitle = "";
          if (layerT.title){
            layerTTitle = layerT.title;
          }else{
            layerTTitle = layerT.get('title');
          }
          //console.log("layer_statelayers", layer_statelayers);
          //console.log("title comparison", layer_statelayers.get('title'), layerTTitle);
          if (layer_statelayers.get('title') === layerTTitle){
            reStateLayers.push(layer_statelayers);
          }
        })
      })
      //console.log("reStateLayers", reStateLayers);
      this.setState({
        layers: reStateLayers
      });
    }
    //console.log("Layer-DEV ---------------------------------------------------------");
    //console.log("Layer-DEV this.state.layers AFTER 2ND STATE CHANGE", this.state.layers);
    //console.log("Layer-DEV this.map[layerList] AFTER 2ND STATE CHANGE", this.map["layerList"]);
    //console.log("Layer-DEV this.map[layerListOnLoad] AFTER 2ND STATE CHANGE", this.map["layerListOnLoad"]);
    //console.log("Layer-DEV this.map[originalLayerOrder] AFTER 2ND STATE CHANGE", this.map["originalLayerOrder"]);
    //console.log("Layer-DEV passLayer", passLayer)
    //console.log("Layer-DEV onPageLoadContext", onPageLoadContext)
    //console.log("Layer-DEV this.map[layersLoadedFrom]", this.map["layersLoadedFrom"] )
    //console.log("Layer-DEV ---------------------------------------------------------");
    if ((!onPageLoadContext)&&(this.map["layersLoadedFrom"][0] === "database")&&(!this.map["layersLoadedFrom"][1])) {
      //would like to remove this call to emit, it should be unecesscary but been used in past to ensure layer order
      this.map["layersLoadedFrom"][1] = true;
      this.map["originalLayerOrder"] = this.map["layerList"];
      this.emitLayerList('layerOrderChange',false,false,false,"handleLayerAddRemove");
    }else{
      if (!onPageLoadContext && !deleted){
        passLayer = layer;
        //this.emitLayerList('layerChange',passLayer,false,false,"handleLayerAddRemove");
      }

    }    
    if (!onPageLoadContext) {
      //this.map["originalLayerOrder"] = this.map["layerList"];
      //console.log("Layer-DEV this.map[originalLayerOrder]", this.map["originalLayerOrder"] );
      this.emitLayerList('layerOrderChange',false,false,false,"handleLayerAddRemove");
    }

    //console.log("Layer-DEV +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
    //console.log("Layer-DEV this.state.layers FINAL STATE CHANGE", this.state.layers);
    //console.log("Layer-DEV this.map[layerList] FINAL STATE CHANGE", this.map["layerList"]);
    //console.log("Layer-DEV this.map[layerListOnLoad] FINAL STATE CHANGE", this.map["layerListOnLoad"]);
    //console.log("Layer-DEV this.map[originalLayerOrder] FINAL STATE CHANGE", this.map["originalLayerOrder"]);
    //console.log("Layer-DEV passLayer", passLayer)
    //console.log("Layer-DEV onPageLoadContext", onPageLoadContext)
    //console.log("Layer-DEV this.map[layersLoadedFrom]", this.map["layersLoadedFrom"] )
    //console.log("Layer-DEV +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
  }

  async componentDidMount() {
    const token = await fetchJwtToken(this.serverUrl);

    this.socket = this.context!;

    this.apolloClient = new ApolloClient({
      uri: process.env.REACT_APP_GRAPHQL_URI,
      headers: {
        // 'x-hasura-admin-secret': 'asdf',
        'Authorization': `Bearer ${token}`,
      },
    });

    this.initialLoad();

    // was at one point necessary to separate map object creation from rest
    // of initialization, but isn't anymore
    const node = ReactDOM.findDOMNode(this) as HTMLElement;
    this.map = createMapObject(node, this.props.config);
    this.props.passMap(this.map)
    this.props.passLayers(this.map.layerList)
    /*
    var layers = this.map.layerList
    const layersMsg = {
      command: 'layerChange',
      layers,
      caller: 'initialized map',
    };
    this.socket.emit('map', layersMsg);
    */
    // openlayers map needs to be notified when its container resizes.
    // This is a slightly hacky way to do it but the alternative would be passing
    // the ref to this component all the way back up to the dashboard like this:
    // https://stackoverflow.com/a/37950970
    // which would be a pain.
    // Downside is this will get called if ANY dashboard widget is resized.
    window.addEventListener('grid-layout-container-resize', (evt: any) => {
      // console.log('map got grid-layout-container-resize');
      this.map.updateSize();
    });

    initMap(
      this.apolloClient, //1
      this.map, //2
      this.serverUrl, //3 
      this.socket, //4
      node, //5
      () => this.toggleMenuExpand(), //6
      (l: any, t:any, s:any) => this.handleLayerAddRemoveDataWarehouse(l,t,s), //7  // This function is know as handleLayerAddRemoveDataWarehouse in mapInit.ts
      (l: any, deleted: boolean, onPageLoadContext: boolean, caller:any) => this.handleLayerAddRemove(l, deleted, onPageLoadContext, caller), //8  // This function is know as addRemoveComponentLayer in mapInit.ts
      this.props.setWidgetTitleStatus, //9
      () => this.handleTileOutlinesRequest(), //10
      (l: any) => this.updateAOIQuery(l), //11
      this.apolloClient, //12
      (l: any, t:any, s:any) => this.handleLayerAddRemoveService(l,t,s), //13
    );

    // Note we don't need an ApolloProvider in the actual component because
    // the list of layers is driven by the layer 'add' listener.
    // Adding the layers to the openlayers map
    // within the ApolloProvider renderer wouldn't make sense.
    this.apolloClient.query({
      query: ALL_LAYERS_QUERY,
    }).then((result: any) => {
      const rows = result.data.syncarto_app_data_source;
      console.log("rows x", rows)
      this.setState({
        availableLayers: [...rows],
      });
      console.log("this.state.availableLayers",this.state.availableLayers)
    });

    this.setState({
      availableLayerServices: [
        //{"id":"WMS", "name": "Web Map Service (WMS)"},
        //{"id":"WFS", "name": "Web Feature Service (WFS)"},
        //{"id":"WMTS", "name": "Web Map Tile Service (WMTS)"},
        {"id":"XYZ", "name": "XYZ Tile Layer (XYZ)"},
        {"id":"MVT", "name": "MapBox Vector Tiles (MVT)"},
      ]
    })    
    this.setState({
      availableLayerStyles: {
        //"WMS" : {"styled": true},
        //"WFS" : { "styled": false},
        //"WMTS" : { "styled": false},
        "XYZ" : { 
          "styled": false, 
          "instanceURL": "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"},
          "MVT" : { "styled": false, "instanceURL": "https://tiles.regrid.com/api/v1/parcels/{z}/{x}/{y}.mvt?token=" + process.env.REACT_APP_REGRID_TOKEN}
      }
    })
    
    this.socket.on('map', (msg: any) => {
      console.log('mapwidget got map message', msg);
      
      if (msg.command === 'layerStyleChange') {
        console.log("about to handle layerStyleChange msg", msg)
        // Find layer by name
        this.map.getLayers().getArray().forEach((layer_: any) => {
          //console.log("layer_", layer_)
          const layerTitle = layer_.get('title');
          if (layerTitle) {
            if (msg.styleTitle === layerTitle){
              for (const mLayer of msg.layers) {
                if (mLayer.title === layerTitle){
                  //console.log("cast style from: mLayer to layer_", mLayer , layer_);
                  layer_.dwdataLayerStyle = mLayer.layerParams.layerStyle;
                }
              }
            }
          }  
        });
        this.updateDwLayers();
      }        
      if (msg.command === 'layerQueryChange') {
        console.log("about to handle layerQueryChange msg", msg)
        // Find layer by name
        this.map.getLayers().getArray().forEach((layer_: any) => {
          //console.log("layer_", layer_)
          const layerTitle = layer_.get('title');
          if (layerTitle) {
            if (msg.styleTitle === layerTitle){
              for (const mLayer of msg.layers) {
                if (mLayer.title === layerTitle){
                  //console.log("cast query from: mLayer to layer_", mLayer , layer_);
                  layer_.dwdataQueryConfig = mLayer.layerParams.queryConfig;
                }
              }
            }
          }  
        });
        this.updateDwLayers();
      }      
      if (msg.command === 'layerOrderChange') {
        console.log("about to handle layerOrderChange msg", msg)
        this.handleLayerOrderChange(msg.layers.map((l: any) => l.title));
      }
      if (msg.command === 'dwLayerChange' && msg.widgetInstanceId) {
          console.log('about to handle dwLayerChange', msg);
          if (msg.widgetInstanceId !== this.props.widgetInstance.id) {
              // only listen to the same widget instance;
              // allows multiple independent maps per session
              return;
          }
          //var dwLayerTitle = this.presentLayerName;
          var dwLayerTitle = msg.layerName; //"Data Warehouse";
          var existingTitles:any = []
          this.map.getLayers().getArray().forEach((layer_: any) => {
            const layerTitle = layer_.get('title');
            if (layerTitle) {
              existingTitles.push(layerTitle)
            }
          });
          if (existingTitles.includes(dwLayerTitle)){
            let i:number = 2;
            while (i < 300) {
              if (existingTitles.includes(dwLayerTitle + " " + i)){
                // This name already exists, increment.
              }else{
                // This name is free, assign and break out.
                dwLayerTitle = dwLayerTitle + " " + i;
                break;
              }
              i++;
            }
          }else{
            // do nothing 
          }

    
          if (msg.queryConfig.hasOwnProperty('_title')){
            dwLayerTitle = msg.queryConfig._title;
          }
          console.log("msg ", msg);
          this.loadDwLayer(msg, dwLayerTitle,true);
      }
      if (msg.command === 'serviceLayerChange' && msg.widgetInstanceId) {
          console.log('about to handle serviceLayerChange', msg);
          if (msg.widgetInstanceId !== this.props.widgetInstance.id) {
              // only listen to the same widget instance;
              // allows multiple independent maps per session
              return;
          }
          // Disambiguate layer titles
          var serviceLayerTitle = msg.layerName; //"Data Warehouse";
          console.log('112921 serviceLayerTitle BEFORE', serviceLayerTitle);
          var existingTitles:any = []
          this.map.getLayers().getArray().forEach((layer_: any) => {
            const layerTitle = layer_.get('title');
            if (layerTitle) {
              existingTitles.push(layerTitle)
            }
          });
         if (existingTitles.includes(serviceLayerTitle)){
            let i:number = 2;
            while (i < 300) {
              if (existingTitles.includes(serviceLayerTitle + " " + i)){
                // This name already exists, increment.
              }else{
                // This name is free, assign and break out.
                serviceLayerTitle = serviceLayerTitle + " " + i;
                break;
              }
              i++;
            }
          }else{
            // do nothing 
          }
    
          this.loadServiceLayer(msg, serviceLayerTitle, true);
      }
      if (msg.mapExtentToUse){
        if (msg.mapExtentToUse === "DBExtent") {
          this.emitLayerList('layerOrderChange',false,false,false,"this.socket.on('map'");
        }
      }
  });

  this.socket.on('chart', (msg: any) => {
    console.log('got chart message', msg);
    if(msg.command === 'filtersChanged') {
      this.crossFilters = msg.filters;
      this.updateDwLayers();
    } 
  });

  }

  handleTileOutlinesRequest() {
    const layers = this.state.layers;
    if (!layers.length) {
      console.log("no layers are being displayed; can't request tile outlines");
      return;
    }
    for (const layerX of layers) {  
  
      const dataSourceRow = layerX.get('dataSourceRow');

      if (dataSourceRow && dataSourceRow.collection_id) {
        const tileOutlinesRequest = `find 1000 catalog images in the collection ${dataSourceRow.collection_id}`;
        console.log('tileOutlinesRequest: ', tileOutlinesRequest);
        this.socket.emit('chat', tileOutlinesRequest);
        break; // exit upon first valid layer 
      } else {
        console.warn(layerX.get('title') + "layer does not have a collection_id property; can't request tile outlines");
      }
    }
  }

  toggleMenuExpand() {
    this.setState((state: any) => {
      return {
        menuExpanded: !state.menuExpanded,
      };
    });
  }

  addTileLayer(layer: any, type:any) {
    console.log("Adding layer", layer)
    console.log("Layer type", type)
    if (type === "catalog"){
    this.emitLayerList('layerChange', layer, false,false,"addTileLayer");
    }else{
      console.log("Handle service type")
    }
    
  }
  handleOnSaveNewLayerName(_x:any){
    console.log("handleOnSaveNewLayerName", _x)
  } 
  handleLayerNameChange(_x:any){
    console.log("handleLayerNameChange", _x)
    console.log("this.presentLayerName", this.presentLayerName)
  } 
  handleFormChangeInput(_x:any){
    console.log("handleFormChangeInput", _x)
    this.presentLayerName = _x;
    console.log("this.presentLayerName", this.presentLayerName)
  }   
  handleServiceLayerNameChange(_x:any){
    console.log("handleServiceLayerNameChange > _x", _x)
    console.log("this.presentServiceLayerName", this.presentServiceLayerName)
  } 
  handleServiceFormChangeInput(_x:any){
    console.log("handleServiceFormChangeInput > _x", _x)
    this.presentServiceLayerName = _x;
    console.log("this.presentServiceLayerName", this.presentServiceLayerName)
  }   
  
  emitLayerList(command: any, newLayer: any = null, deletedLayer: any = null, styledLayer: any = null, caller: any = null) {
    console.log("emitLayerList() > command, newLayer, deletedLayer, styledLayer, caller", command, newLayer, deletedLayer, styledLayer, caller)
        
    if (newLayer){
      var disambiguateTitles = newLayer.title;
      var existingTitles:any = []
      this.map.getLayers().getArray().forEach((layer_: any) => {
        const layerTitle = layer_.get('title');
        if (layerTitle) {
          existingTitles.push(layerTitle)
        }
      });
      console.log("existingTitles", existingTitles)
      console.log("disambiguateTitles", disambiguateTitles)
      if (existingTitles.includes(disambiguateTitles)){
        let i:number = 2;
        while (i < 300) {
          if (existingTitles.includes(disambiguateTitles + " " + i)){
            // This name already exists, increment.
          }else{
            // This name is free, assign and break out.
            disambiguateTitles = disambiguateTitles + " " + i;
            break;
          }
          i++;
        }
        newLayer.title = disambiguateTitles;
      }else{
        // do nothing
      }
      console.log("disambiguateTitles", disambiguateTitles)
      if(this.map.originalLayerOrder){
        //this.map.originalLayerOrder.push(newLayer);
        console.log("this.map.originalLayerOrder.unshift(newLayer); ", newLayer)
        //this.map.originalLayerOrder.unshift(newLayer);
        this.map.originalLayerOrder = this.map.layerListOnLoad;
      }             
      if(this.map.layerListOnLoad){
        //this.map.layerListOnLoad.push(newLayer);
        this.map.layerListOnLoad.unshift(newLayer);
        console.log("this.map.layerListOnLoad", this.map.layerListOnLoad)
      }
    }
    console.log("this.map.originalLayerOrder", this.map.originalLayerOrder)
    console.log("this.map.layerListOnLoad", this.map.layerListOnLoad)
    // TODO define type for object in persisted layer list
    let layers: any[] = this.state.layers.map((layer: any) => {
      /*
      console.log("layer --> ", layer.get('dataSourceRow'));
      console.log("layer --> ", layer.get('title'));
      console.log("layer --> ", layer.get('yearStart'));
      console.log("layer --> ", layer.get('yearEnd'));
      console.log("layer --> ", layer.getVisible());
      console.log("layer --> ", layer.get('cogUrl'));
      console.log("layer --> ", layer.interpId);
      */
      console.log('source', layer.get('source'));
      if ((layer.interpId) || (layer.get('dataSourceRow'))||(layer.get('cogUrl'))/*||(layer.get('source').key_)*/||layer.hasOwnProperty('dwdataQueryConfig')){
        //console.log("layer", layer)
        if (layer.hasOwnProperty('dwdataQueryConfig')){ // DW Layer
          console.log("DW layer encountered --> layer = ", layer);
          console.log('config Updated > layer.get(dwdataQueryConfig)', layer['dwdataQueryConfig']);
          console.log("layer > layerDefID?", layer)
          console.log("layer > this.state.selectedDefinitionWrapper", this.state.selectedDefinitionWrapper)
          let existngDWParams = {
            chartType: "dwLayer", //this.state.selectedChartProvider.name,
            layerDefID: layer.dwdataQueryConfig.definitionId,
            queryConfig: layer['dwdataQueryConfig'],
            layerStyle: layer['dwdataLayerStyle'],
            widgetInstanceId: this.props.widgetInstance.id,
            widgetInstanceTitle: this.props.widgetInstance.title,
          }
    
          return {
            layerParams: existngDWParams, // pass parameters for storing in layers.json
            title:layer.get('title'),
            visible: layer.getVisible(),
          }
        }else{ // Tile Layer
          console.log("tile layer encountered --> layer = ", layer);
          if (layer instanceof WebGLTileLayer){ // COG
            console.log("COG layer encountered --> layer = ", layer);
            let cogPath = ""
            if (layer.get('source')){
              cogPath = layer.get('source').key_;
            }else{
              cogPath = layer.get('cogUrl');
            }
            return {
              cogUrl: layer.get('source').key_,
              title: layer.get('title'),
              visible :layer.getVisible(), //this.props.widgetInstance.visible
              "origin": "mapWidget A",
            }
          }else{ // Tile
            console.log("tile layer encountered --> layer = ", layer);
            return {
              dataSourceRow: layer.get('dataSourceRow'),
              title: layer.get('title'),
              yearStart: layer.get('yearStart'),
              yearEnd: layer.get('yearEnd'),
              visible: layer.getVisible(),
              cogUrl: layer.get('cogUrl'),
              interpId: layer.interpId,
            }
          }
        }
      }else{
        if ((layer instanceof TileLayer)||(layer instanceof VectorTileLayer)){ //User-defined XYZ TileLayer, or MVT VectorTile layer
          let unaddedServiceParams = {
            chartType: "serviceLayer",
            serviceConfig: layer['serviceLayerConfig'],
            layerStyle: layer['serviceLayerStyle'],
            widgetInstanceId: this.props.widgetInstance.id,
          };
          return {
            "layerParams": unaddedServiceParams,
            "title":layer.get('title'),
            "visible":layer.getVisible(), //this.props.widgetInstance.visible
          }
        }else{
          console.log("layer else", layer)
        let unaddedDWParams = {
          queryConfig: this.state.queryConfig, 
            layerStyle: {highRenderedColor: this.presentLayerHighColor, lowRenderedColor: this.presentLayerLowColor, highRenderedPoint: this.presentLayerHighPoint, lowRenderedPoint: this.presentLayerLowPoint, strokeColor: "#ffffff", configOrigin: "mapWidget constructor x", maxVal: null, minVal: null} //this.state.presentLayerStyle, //layer['dwdataLayerStyle'],
        } 
        return {
          "layerParams": unaddedDWParams,
          "title":layer.get('title'),
          "visible":layer.getVisible(), //this.props.widgetInstance.visible
        }
      }
      }
    });
    if (deletedLayer) {
      layers = layers.filter((l: any) => l.title !== deletedLayer.get('title'));
      if(this.map.originalLayerOrder){
        if(this.map.originalLayerOrder.length > 0){
          console.log("deleting layer", deletedLayer)
          let tempLayersDelete = [];
          //this.map.originalLayerOrder = this.map.originalLayerOrder.filter((l: any) => l.get('title') !== deletedLayer.get('title'));
          for (const l of this.map.originalLayerOrder) { 
            let titleDelete = "not set";
            if (l.title){ 
              titleDelete = l.title;
            }else{ 
              titleDelete = l.get('title');
            }
            console.log("titleDelete", titleDelete)
            console.log("deletedLayer.get('title')", deletedLayer.get('title'))
            if ( titleDelete !== deletedLayer.get('title')){
              tempLayersDelete.push(l);
            }
          }
          this.map.originalLayerOrder = tempLayersDelete;
        }             
      }             
      if(this.map.layerListOnLoad){
        this.map.layerListOnLoad = this.map.layerListOnLoad.filter((l: any) => l.title !== deletedLayer.get('title'));
        console.log("A092521B DELETED LAYER!? ", this.map.layerListOnLoad)
      }
      //console.log("Layer-DEV this.map['originalLayerOrder'],", this.map["originalLayerOrder"])
      //console.log("Layer-DEV this.map['layerListOnLoad'],", this.map["layerListOnLoad"])
    }

    if (newLayer) {
      console.log("newLayer", newLayer)
      var layer_min_date:string = "";
      var layer_max_date:string = "";
      if (newLayer.date_display_resolution === "year"){
        layer_min_date = (newLayer.min_date).split("-")[0]; // grab just the year
        layer_max_date = (newLayer.max_date).split("-")[0];
      }      
      if (newLayer.date_display_resolution === "day"){
        layer_min_date = newLayer.min_date; // allow day to remain 
        layer_max_date = newLayer.max_date;
      }
      layers.unshift({
        dataSourceRow: newLayer,
        title: disambiguateTitles, //newLayer.title,
        yearStart: layer_min_date, 
        yearEnd: layer_max_date,
        visible: true, // New layer should always be visible
        dateDisplayResolution: newLayer.date_display_resolution,
      });
    
      console.log("this.state", this.state)
      console.log("this.props", this.props)
    }
    var params: any = {
      command,
      layers,
    };
    //console.log("Layer-DEV this.map,", this.map)
    //console.log("Layer-DEV this.map['layerList'],", this.map["layerList"])
    //console.log("Layer-DEV layers,", layers)
    //console.log("Layer-DEV this.map['originalLayerOrder'],", this.map["originalLayerOrder"])
    //console.log("Layer-DEV this.map['layerListOnLoad'],", this.map["layerListOnLoad"])
    
    this.map["layerList"] = layers;
    if ((command === 'layerStyleChange')|| (command === 'layerQueryChange')){
      console.log("layers", layers)
      console.log("styledLayer", styledLayer)
      var styleTitle = styledLayer.get('title')
      console.log("styleTitle", styleTitle)
      params = {
        command,
        layers,
        styleTitle,
      };
      this.socket.emit('map', params);

    }else{
      if (deletedLayer) {
        params.deletedLayer = deletedLayer.get('title');
      }
      /*if(this.map){
        if(layers){
            console.log("layers")
            for (const L0 of layers) {
                console.log("layers > ", L0.title);
            }  
        }      
        if(this.map.originalLayerOrder){
            console.log("originalLayerOrder")
            for (const mL of this.map.originalLayerOrder) {
                console.log("originalLayerOrder > ", mL.get('title'));
            }  
        }             
        if(this.map.layerList){
            console.log("layerList")
            for (const mLX of this.map.layerList) {
                console.log("layerList > ", mLX.title);
            }  
        } 
        console.log("layerListOnLoad");     
        if(this.map.layerListOnLoad){
            for (const mL2 of this.map.layerListOnLoad) {
                console.log("layerListOnLoad > ", mL2.title);
            }
        }
      }*/
      let tempLayers = [];
      let allLayersPresent = false;
      if (!this.map.originalLayerOrder){
        this.map["originalLayerOrder"] = [];
      }
      if(this.map.originalLayerOrder.length > 0){
        console.log("Layer-DEV this.map.originalLayerOrder > ", this.map.originalLayerOrder);
        console.log("Layer-DEV params BEFORE A > ", params);
        if (this.map.originalLayerOrder.length === params.layers.length){
          allLayersPresent = true;
          //console.log("Layer-DEV EMITTING A ");
          for (const l of this.map.originalLayerOrder) { 
            for (const lO of params.layers) { 
              let titleL = "not set";
              if (l.title){ titleL = l.title}else{ titleL = l.get('title') }
              if (lO.title === titleL){
                tempLayers.push(lO)
              }
            }
          }
          params.layers = tempLayers;
          console.log("Layer-DEV emitting params AFTER A > ", params);
          this.socket.emit('map', params);
        }else{
          console.log("Layer-DEV SKIPPING A ", params);
          // Do nothing for now
        }
      }else{
        console.log("Layer-DEV params ELSE B > ", params);
        //this.socket.emit('map', params);
        if (this.map.layerListOnLoad.length === params.layers.length){
          allLayersPresent = true;
          //console.log("Layer-DEV EMITTING B ");
          for (const l of this.map.layerListOnLoad) { 
            for (const lO of params.layers) { 
              if (lO.title === l.title){
                tempLayers.push(lO)
              }
            }
          }
          params.layers = tempLayers;
          console.log("Layer-DEV emitting params AFTER B > ", params);
          this.socket.emit('map', params);
        }else{
          console.log("Layer-DEV SKIPPING B");
          // Do nothing for now
        }
      }
      // Sync all layer varibles, be mindful of format
      //
      if (allLayersPresent){
        console.log("allLayersPresent");
        /*console.log("----------- BEFORE")
        if (this.map.originalLayerOrder){
          this.map.originalLayerOrder.forEach((layer_originalLayerOrder: any) => {
            console.log("layer_originalLayerOrder", layer_originalLayerOrder )
          })
        }
        this.map.layerListOnLoad.forEach((layer_layerListOnLoad: any) => {
          console.log("layer_layerListOnLoad", layer_layerListOnLoad )
        })
        this.map.layerList.forEach((layer_layerList: any) => {
          console.log("layer_layerList", layer_layerList )
        })    
        layers.forEach((layer_layers: any) => {
          console.log("layer_layers", layer_layers )
        })    
        this.state.layers.forEach((layer_statelayers: any) => {
          console.log("layer_statelayers", layer_statelayers )
        })
        console.log("this.map",this.map )
        tempLayers.forEach((layerT: any) => {
          console.log("layerT", layerT )
        })*/
        
        // cast layer order to layers var
        layers = tempLayers;
        // cast layer order to this.map.layerListOnLoad var
        //console.log("Layer-DEV this.map.layerListOnLoad", this.map.layerListOnLoad)
        this.map.layerListOnLoad = tempLayers;
        //console.log("Layer-DEV this.map.layerListOnLoad", this.map.layerListOnLoad)
        // cast layer order to this.map.layerList var
        this.map.layerList = tempLayers;
        // cast layer order to this.map.originalLayerOrder var
        // this.map.layerList = tempLayers;

        // cast layer order to this.state.layers (zIndex)
        //console.log("Layer-DEV ----------- AFTER")
        if (this.map.originalLayerOrder){
          this.map.originalLayerOrder.forEach((layer_originalLayerOrder: any) => {
            //console.log("Layer-DEV layer_originalLayerOrder", layer_originalLayerOrder )
          })
        }
        this.map.layerListOnLoad.forEach((layer_layerListOnLoad: any) => {
          //console.log("Layer-DEV layer_layerListOnLoad", layer_layerListOnLoad )
        })
        this.map.layerList.forEach((layer_layerList: any) => {
          //console.log("Layer-DEV layer_layerList", layer_layerList )
        })    
        layers.forEach((layer_layers: any) => {
          //console.log("Layer-DEV layer_layers", layer_layers )
        })    
        let zIndexes:any = [];
        this.state.layers.forEach((layer_statelayers: any) => {
          zIndexes.push(layer_statelayers.get('zIndex'));
        })
        zIndexes.sort(function(a:any, b:any) { // sort array lowest to highest
          return a - b;
        });
        //console.log("Layer-DEV zIndexes", zIndexes )
        //console.log("Layer-DEV this.map", this.map )
        
        let zPosition:any = zIndexes.length - 1;
        let newStateLayers:any = [];
        tempLayers.forEach((layerT: any) => {
          this.state.layers.forEach((layer_statelayers: any) => {
            if (layerT.title === layer_statelayers.get('title')){
              //console.log("Layer-DEV layerT", layerT )
              //console.log("Layer-DEV zIndexes[zPosition]", zIndexes[zPosition])
              layer_statelayers.setZIndex(zIndexes[zPosition])
              zPosition--;
              newStateLayers.push(layer_statelayers)
            }
          })
        })
        this.setState( {
          layers: newStateLayers
        });
      }
    }
  }
  // End emitLayerList();

  onChangeDefinition(e: any) {
    // eslint-disable-next-line
    let wrapper = this.state.definitionWrappers.find((d: any) => d.id === e.target.value);

    console.log('onChangeDefinition', e.target.value, wrapper, this.state.definitionWrappers);

    this.setState( {
        selectedDefinitionWrapper: wrapper.definition
    });
  }

  onChangeMapService(e: any) {

    console.log('onChangeMapService', e.target.value);

    this.setState( {
      selectedLayerService:  e.target.value,
    });    
    this.setState( {
      selectedLayerServiceObject:  this.state.availableLayerStyles[e.target.value],
    });

  }

  mapPropertiesForm(): React.ReactNode {    
    const { definitionWrappers, selectedDefinitionWrapper } = this.state;

    if (this.state.definitionWrappers.length === 0) {
        return (<div>Loading...</div>);
    }
    console.log("definitionWrappers", definitionWrappers)
    // Create (not reconfigure) data warehouse form
    return (
        <div>
          <div className="mb-3 p-3 bg-dark">
            <MapRenameDwLayer
                handleFormChangeInputFromComponent={(v: any) => this.handleFormChangeInput(v)} // returns new layer name
                handleLayerNameChangeFromComponent={(e: any) => this.handleLayerNameChange(e)} // returns save new layer event 
                handleOnSaveNewLayerName={(e: any) => this.handleOnSaveNewLayerName(e)}
                layer={null}
              />   
          </div> 
          <div className="mb-3 p-3 bg-dark"> 
              <Form.Label>Data Source</Form.Label>
              <Form.Control as="select" name="definition"
                  onChange={this.onChangeDefinition.bind(this)}
                  defaultValue={selectedDefinitionWrapper ? selectedDefinitionWrapper.id : undefined}>
                  <option value={selectedDefinitionWrapper ? selectedDefinitionWrapper.id : undefined}>Select a data source definition</option>
                  {definitionWrappers.map((d:any) => <option key={d.id} value={d.id}>{`${d.name} (${d.definition.name})`}</option>)}
              </Form.Control>
            { selectedDefinitionWrapper ?           
              <div className="mt-3">
                <MapDwForm 
                  ref={this.childrefMapWidget}
                  definition={selectedDefinitionWrapper}
                  queryConfig={null}
                  saveConfig={this.configUpdated}
                ></MapDwForm>
              </div>
              :''
            }
            </div>
        
        { selectedDefinitionWrapper ?
          <div className="mb-3 p-3 bg-dark">            
            <MapStyleDwLayer
              ref={this.childRefDwStyle}
              layer={null}
              definition={selectedDefinitionWrapper}
              saveColor={(highColor:any,lowColor:any,highPoint:any,lowPoint:any, max:any, min:any) => this.colorUpdated(highColor,lowColor,highPoint,lowPoint, max, min)}
            />
          </div>
          :''
        }
        </div> 
    );
  }
  
  mapServicesForm(): React.ReactNode {    
    const { availableLayerServices, selectedLayerService, availableLayerStyles, selectedLayerServiceObject  } = this.state;
    //console.log("availableLayerServices, selectedLayerService, availableLayerStyles", availableLayerServices, selectedLayerService, availableLayerStyles)
    return (
        <div>
          <div className="mb-3 p-3 bg-dark">
            <MapRenameDwLayer
                handleFormChangeInputFromComponent={(v: any) => this.handleServiceFormChangeInput(v)} // returns new layer name
                handleLayerNameChangeFromComponent={(e: any) => this.handleServiceLayerNameChange(e)} // returns save new layer event 
                handleOnSaveNewLayerName={(e: any) => this.handleOnSaveNewLayerName(e)}
                layer={null}
              />   
          </div> 
          <div className="mb-3 p-3 bg-dark"> 
              <Form.Label>Service Type</Form.Label>
              <Form.Control as="select" name="definition"
                  onChange={this.onChangeMapService.bind(this)}
                  defaultValue={selectedLayerService ? selectedLayerService.id : undefined}
              >
                  <option key="none" value={selectedLayerService ? selectedLayerService.id : undefined}>Select a map service type</option>
                  {availableLayerServices.map((d:any) => <option key={d.id} value={d.id}>{`${d.name}`}</option>)}
              </Form.Control>
            { selectedLayerService ?           
              <div className="mt-3">
                <MapServiceLayerForm 
                  ref={this.childRefMapServiceConfig}
                  selectedLayerService={selectedLayerService} 
                  selectedLayerServiceObject={selectedLayerServiceObject} 

                  saveServiceConfig={(serviceConfig: any, _layer:any) => this.serviceConfigUpdated(serviceConfig, _layer)}
                ></MapServiceLayerForm>
              </div>
              :''
            }
            </div>
        </div> 
    );
  } 
  
  colorUpdated(highColor:any,lowColor:any, highPoint:any, lowPoint:any, max:any, min:any){
    console.log("colorUpdated > highColor,lowColor,highPoint,lowPoint, max, min", highColor,lowColor,highPoint,lowPoint, max, min )
    this.presentLayerHighColor = highColor;
    this.presentLayerLowColor = lowColor; // lowColor
    this.presentLayerHighPoint = highPoint;
    this.presentLayerLowPoint = lowPoint; // lowColor
    this.presentLayerMinVal = min;
    this.presentLayerMaxVal = max;
  }    
  
  handleChangeColor(e:any){
    this.presentLayerHighColor = e;
    this.presentLayerLowColor = e;
  }   
  handleSaveColor(e:any){
    this.presentLayerHighColor = e;
    this.presentLayerLowColor = e;
  }  
  
  layerStyleUpdated(highColor:any, lowColor:any, highPoint:any, lowPoint:any,_layer:any, max:any, min:any){
    console.log("highColor, lowColor, highPoint, lowPoint,_layer", highColor, lowColor, highPoint, lowPoint,_layer, max, min)
    this.presentLayerHighColor = highColor;
    this.presentLayerLowColor = lowColor;
    _layer.dwdataLayerStyle.highRenderedColor = this.presentLayerHighColor; //NOTE: ! we must update the layer object immediately so as to not break reactiveness w/layer card (legend) in TOC.
    _layer.dwdataLayerStyle.lowRenderedColor = this.presentLayerLowColor; // See NOTE, above.
    this.presentLayerHighPoint = parseInt(highPoint);
    this.presentLayerLowPoint = parseInt(lowPoint);
    _layer.dwdataLayerStyle.highRenderedPoint = this.presentLayerHighPoint; // See NOTE, above.
    _layer.dwdataLayerStyle.lowRenderedPoint = this.presentLayerLowPoint; // See NOTE, above.    
    this.presentLayerMinVal = min;
    this.presentLayerMaxVal = max;
    _layer.dwdataLayerStyle.minVal = this.presentLayerMinVal; // See NOTE, above.
    _layer.dwdataLayerStyle.maxVal = this.presentLayerMaxVal; // See NOTE, above.    

    var loadedLayerOrder = [];
    for (const mLayer of this.map.layerList) {
        console.log("Layer,", mLayer);
        if (mLayer.title){
          loadedLayerOrder.push(mLayer.title);
        }
    }   
       
    var preserveDwdataQueryConfig:any = _layer.dwdataQueryConfig;
    var preserveDwdataChartType:any =_layer.dwdataChartType;
    var preserveDwdataLayerStyle:any = _layer.dwdataLayerStyle;
    var processedFeatures: any = _layer.processedFeatures;
    
    var preserveVisible:boolean = _layer.get('visible');
    var styleToAdjust:any = _layer.get('style');
    var titleToKeep:any = _layer.get('title');
    if (_layer instanceof WebGLPointsLayer){ // If this is a point layer, the features need to be removed and added again in order to symbolize correctly
      console.log("Removing old layer");
      this.map.removeLayer(_layer);
      this.handleLayerAddRemove(_layer,true,false,"1223");
      _layer.dispose();

      console.log('styleToAdjust', styleToAdjust);

      styleToAdjust.symbol.size[4] = this.presentLayerLowPoint;
      styleToAdjust.symbol.size[6] = this.presentLayerHighPoint;
      styleToAdjust.symbol.color = colorStyleToWebGlStyle(highColor, preserveDwdataLayerStyle.minVal, preserveDwdataLayerStyle.maxVal);
      
      console.log("Adding new layer")
      const vectorLayer = new WebGLPointsLayer({
        source: new VectorSource(),
        style: styleToAdjust,
        disableHitDetection: false,
      });

      vectorLayer.getSource().clear();
      vectorLayer.getSource().addFeatures(processedFeatures);

      vectorLayer["dwdataQueryConfig"] = preserveDwdataQueryConfig;
      vectorLayer["dwdataChartType"] = preserveDwdataChartType;
      vectorLayer["dwdataLayerStyle"] = preserveDwdataLayerStyle;
      vectorLayer["processedFeatures"] = processedFeatures;

      vectorLayer.set('title', titleToKeep);
      vectorLayer.setVisible(preserveVisible);
      this.map.addLayer(vectorLayer);
      this.handleLayerAddRemove(vectorLayer,false,false, "1243");
      vectorLayer.setZIndex(100);

      this.handleLayerStyleChange(loadedLayerOrder, true, vectorLayer); 
    }else{ // Just need to refresh the map if this is a GeoJSON (field) layer 
      this.handleLayerStyleChange(loadedLayerOrder, true, _layer); 
      // Need to update the layer on map but options such as; this.map.render(); _layer.getSource().refresh(); layer.changed(); do not work. 
      // trigger slight zoom in to force the GeoJSON style function 
      this.map.getView().setZoom(this.map.getView().getZoom() + 0.00001);
      console.log("121621 this.map", this.map)
    }
    console.log("this.map", this.map)
    console.log("this.map.getLayers().getArray()", this.map.getLayers().getArray())
    this.updateDwLayers();
  }

  serviceConfigUpdated(serviceConfig: any, _layer: any = null) {
      console.log('serviceConfigUpdated > serviceConfig, this, _layer', serviceConfig, this, _layer);
      
      // Use existing map layers to build json config of layers stack (will be emitted to others on the session and layers.json)
      // 
      let layers: any[] = this.state.layers.map((layer: any) => {
        console.log("DW layer encountered --> layer = ", layer);

        if (layer.hasOwnProperty('dwdataQueryConfig')) {
          let existngDWParams = {
            chartType: "dwLayer",
            layerDefID: layer.dwdataQueryConfig.definitionId,
            queryConfig: layer['dwdataQueryConfig'],
            layerStyle: layer['dwdataLayerStyle'],
            widgetInstanceId: this.props.widgetInstance.id,
            widgetInstanceTitle: this.props.widgetInstance.title,
          }
          return {
            layerParams: existngDWParams, // pass parameters for storing in layers.json
            title:layer.get('title'),
            visible: layer.getVisible(),
          }
        } else {
          if ((layer instanceof TileLayer)||(layer instanceof VectorTileLayer)){ 
            let unaddedServiceParams = {
              chartType: "serviceLayer",
              serviceConfig: layer['serviceLayerConfig'],
              layerStyle: layer['serviceLayerStyle'],
              widgetInstanceId: this.props.widgetInstance.id,
            };
            return {
              "layerParams": unaddedServiceParams,
              "title":layer.get('title'),
              "visible":layer.getVisible(), //this.props.widgetInstance.visible
            }
          }else{
            return {
              dataSourceRow: layer.get('dataSourceRow'),
              title: layer.get('title'),
              yearStart: layer.get('yearStart'),
              yearEnd: layer.get('yearEnd'),
              visible: layer.getVisible(),
              cogUrl: layer.get('cogUrl'),
            }
          }
        }
      });

      if (_layer){
        //this.emitLayerList('layerQueryChange',null,null,_layer,"configUpdated");
      }else{
        let unaddedServiceParams = {
          chartType: "serviceLayer",
          serviceConfig: serviceConfig,
          layerStyle: null,
          widgetInstanceId: this.props.widgetInstance.id      
        };
        let serviceLayerName:string = (serviceConfig.hasOwnProperty('_title') ? serviceConfig._title : this.presentServiceLayerName);
        ///
        //var serviceLayerName = msg.layerName; //"Data Warehouse";
        console.log('112921 serviceLayerName BEFORE', serviceLayerName);
        var existingTitles:any = []
        this.map.getLayers().getArray().forEach((layer_: any) => {
          const layerTitle = layer_.get('title');
          if (layerTitle) {
            existingTitles.push(layerTitle)
          }
        });
       if (existingTitles.includes(serviceLayerName)){
          let i:number = 2;
          while (i < 300) {
            if (existingTitles.includes(serviceLayerName + " " + i)){
              // This name already exists, increment.
            }else{
              // This name is free, assign and break out.
              serviceLayerName = serviceLayerName + " " + i;
              break;
            }
            i++;
          }
        }else{
          // do nothing 
        }
        console.log('serviceLayerName AFTER', serviceLayerName);
        console.log('unaddedServiceParams', unaddedServiceParams);
        console.log('layers', layers);
        // The new service layer will not exist on the map yet, so force/add it to top (beginning) of layers list as a placeholder
        //
        layers.unshift({
          "layerParams": unaddedServiceParams, // pass parameters for storing in layers.json
          "title": serviceLayerName,
          "visible":(serviceConfig.hasOwnProperty('_visible') ? serviceConfig._visible : true),
        });

        console.log("emitting these layers:", layers);

        this.map["layerList"] = layers;

        this.socket.emit('map', {
            command: 'serviceLayerChange',
            serviceConfig: serviceConfig,
            layerName:  serviceLayerName,
            layerStyle: null, 
            widgetInstanceId: this.props.widgetInstance.id,
            layers
        });
    
        console.log("... just emitted serviceLayerChange...");
        
        this.closeModal();
    }
  }
 
  configUpdated(queryConfig: any, _layer: any = null) {
      console.log('configUpdated > queryConfig, this, _layer', queryConfig, this, _layer);
      
      // Use existing map layers to build json config of layers stack (will be emitted to others on the session and layers.json)
      // 
      let layers: any[] = this.state.layers.map((layer: any) => {
        console.log("DW layer encountered --> layer = ", layer);

        if (layer.hasOwnProperty('dwdataQueryConfig')) {
          let existngDWParams = {
            chartType: "dwLayer",
            layerDefID: layer.dwdataQueryConfig.definitionId,
            queryConfig: layer['dwdataQueryConfig'],
            layerStyle: layer['dwdataLayerStyle'],
            widgetInstanceId: this.props.widgetInstance.id,
            widgetInstanceTitle: this.props.widgetInstance.title,
          }
          return {
            layerParams: existngDWParams, // pass parameters for storing in layers.json
            title:layer.get('title'),
            visible: layer.getVisible(),
          }
        } else {
          console.log("B layer", layer)
          if (layer.hasOwnProperty('serviceLayerConfig')){
            let existngServiceParams = {
              chartType: "serviceLayer",
              serviceConfig: layer['serviceLayerConfig'],
              layerStyle: layer['serviceLayerStyle'],
              widgetInstanceId: this.props.widgetInstance.id,
            };
            return {
              layerParams: existngServiceParams, // pass parameters for storing in layers.json
              title:layer.get('title'),
              visible: layer.getVisible(),
            }
          }else{
            return {
              dataSourceRow: layer.get('dataSourceRow'),
              title: layer.get('title'),
              yearStart: layer.get('yearStart'),
              yearEnd: layer.get('yearEnd'),
              visible: layer.getVisible(),
              cogUrl: layer.get('cogUrl'),
            }
          }
        }
      });

      if (_layer){
        console.log("C 'layerQueryChange'", _layer)
        this.emitLayerList('layerQueryChange',null,null,_layer,"configUpdated");
      }else{
        let unaddedDWParams = {
          chartType: "dwLayer",
          layerDefID: queryConfig.definitionId,
          queryConfig: queryConfig,
          layerStyle: {highRenderedColor: this.presentLayerHighColor, lowRenderedColor: this.presentLayerLowColor, highRenderedPoint: this.presentLayerHighPoint, lowRenderedPoint: this.presentLayerLowPoint, strokeColor: "#ffffff", configOrigin: "mapWidget constructor c", maxVal: this.presentLayerMaxVal, minVal: this.presentLayerMinVal}, 
          widgetInstanceId: this.props.widgetInstance.id      
        };
        console.log("D unaddedDWParams", unaddedDWParams)
        console.log("D _layer", _layer)
        console.log("D queryConfig", queryConfig)
        // The new DW (data warehouse) layer will not exist on the map yet, so force/add it to top (beginning) of layers list as a placeholder
        //
        layers.unshift({
          "layerParams": unaddedDWParams, // pass parameters for storing in layers.json
          "title": (queryConfig.hasOwnProperty('_title') ? queryConfig._title : this.presentLayerName),
          "visible":(queryConfig.hasOwnProperty('_visible') ? queryConfig._visible : true),
        });

        console.log("emitting these layers:", layers);

        this.map["layerList"] = layers;

        this.socket.emit('map', {
            command: 'dwLayerChange',
            queryConfig: queryConfig,
            layerName: this.presentLayerName,
            layerStyle: {highRenderedColor: this.presentLayerHighColor, lowRenderedColor: this.presentLayerLowColor, highRenderedPoint: this.presentLayerHighPoint, lowRenderedPoint: this.presentLayerLowPoint, strokeColor: "#ffffff", configOrigin: "mapWidget constructor d", maxVal: this.presentLayerMaxVal, minVal: this.presentLayerMinVal}, 
            widgetInstanceId: this.props.widgetInstance.id,
            layers
        });
    
        console.log("... just emitted dwLayerChange...");
        
        this.closeModal();
    }
  }

  applyLayerConfig(_context:any) {
    console.log("020122 applyLayerConfig() > _context", _context)
    switch (_context) {
      case 'Web Service Layer':
        this.childRefMapServiceConfig.current.saveToConfig(null);
        break;
      case 'Data Warehouse Layer':
        this.childRefDwStyle.current.onSave();
        this.childrefMapWidget.current.applyConfig();
        break;
      default:
        break;
    }

    
  }

  closeModal() {
    this.setState({
        showModal: false,
        activeModal:"",
    });
  }

  openModal(_asset:any) {
      this.setState({
          showModal: true,
          activeModal:_asset,
      });
    }  

  handleSwipeChange(e: any) {
    console.log("handleSwipeChange(e... ", e)
    this.setState({
      swipeValue: e.target.value,
    }, () => {
      // re-render the map so the new swipe value takes effect
      this.map.render();
    });
  }

  setMapChartLink(instance: any) {
    if (instance.id) {
      console.log("############################################################################!")
      this.socket.emit('chart', {
        command: 'setMapChartLink',
        widgetInstanceId: instance.id,
        widgetInstanceTitle: instance.title,
      });
    }
  }

  setShowHoverButtons(tf:boolean){ 
    this.setState({
      showHoverButtons: tf
    });
  }
  render() {
    // console.log('mapWidget', this.props.widgetInstances, this.props.widgetTypes);
    //let graphWidgetTypeId: number;
    if (this.props.widgetTypes) {
      const results = this.props.widgetTypes.filter((widgetType: any) => widgetType.name === "Graph Widget");
      if (results.length) {
        //graphWidgetTypeId = results[0].id;
      }
    }

    return (<div id="map-container"
        onMouseEnter={() => this.setShowHoverButtons(true)}
        onMouseLeave={() => this.setShowHoverButtons(false)}
    >
      <div className="mouse-event-div"></div>
      <div className={this.state.showHoverButtons ? "map-widget-hover-buttons" : "map-widget-hover-buttons d-none"} >
      <Dropdown className="layer-dropdown">
          <DropdownToggle className="layer-dropdown-toggle btn-secondary btn-sm" size="sm" variant="secondary" title="Add asset to map" style={{ height: '30px'}} >
            <FontAwesomeIcon icon={faPlus}/>  
          </DropdownToggle>
        <DropdownMenu>
          <MenuItem>
            Map Service
              <MenuItem onClick={() => this.openModal("Web Service Layer")}>
                    Add Web Service Layer
              </MenuItem>
            </MenuItem>
            <MenuItem divider />          
            <MenuItem className="layer-menu">
          Image Catalog
            {this.state.availableLayers.map((l: any, i: number) => (
                <MenuItem key={i} onClick={() => this.addTileLayer(l,"catalog")}>{l.title}</MenuItem>
            ))}
          </MenuItem>
          <MenuItem divider />
          <MenuItem>
              Data Warehouse
              <MenuItem onClick={() => this.openModal("Data Warehouse Layer")}>
                  Add Data Warehouse Layer
              </MenuItem>
          </MenuItem>
        </DropdownMenu>
      </Dropdown>
        <Button variant="secondary" size="sm" style={{ position: 'absolute', top: 0, left: '35px', zIndex:2, height: '30px', width: '33px' }}
            onClick={() => this.toggleMenuExpand()}>
                <FontAwesomeIcon icon={faBars}/>
        </Button>
      </div>
      <div id="map-menu-container" className={this.state.menuExpanded ? "menu-expanded" : "menu-collapsed"} onTransitionEnd={() => this.map.updateSize()}>
        <MapLayers 
          map_={this.map} 
          serverUrl={this.serverUrl}
          layers={this.state.layers}
          emitLayerList={(cmd: any, newLayer: any, deletedLayer: any, styledLayer: any, caller:any) => this.emitLayerList(cmd, newLayer, deletedLayer, styledLayer, caller)}
          handleLayerOrderChange={(msg: any, doEmit: any) => this.handleLayerOrderChange(msg, doEmit)}
          dwDefinition={this.state.selectedDefinitionWrapper}
          configUpdated={(queryConfig: any, _layer:any) => this.configUpdated(queryConfig, _layer)}
          layerStyleUpdated={(highColor: any, lowColor: any, highPoint: any, lowPoint: any, _layer: any, max:any, min:any) => this.layerStyleUpdated(highColor, lowColor, highPoint, lowPoint, _layer, max, min)}
          updateDwLayers={() => this.updateDwLayers()}
          definitionWrappers={this.state.definitionWrappers}
        />
      </div>
      <div id="map-and-swipe-container">
        <div id="map" className="map">
        </div>
        <div id="layer-swipe-container">
          <input id="layer-swipe" type="range" value={this.state.swipeValue} onChange={(e: any) => this.handleSwipeChange(e)} />
        </div>
      </div>
      <div id="generic-popup" className="ol-popup">
        <div className="ol-popup-header">
          <div className="ol-popup-header-left" id="generic-popup-header-title">
            Data Warehouse
          </div>
          <a href="close" id="generic-popup-closer" className="ol-popup-closer"> </a>
        </div>
        <div id="generic-popup-content" className="ol-popup-content"></div>
        <div id="generic-popup-tabcontent" className="ol-popup-tabcontent">
          <div id="generic-popup-tabcontent-info" className="ol-popup-tabcontent-info"></div>
        </div>
      </div>      
      <div id="dw-popup" className="ol-popup">
        <div className="ol-popup-header">
          <div className="ol-popup-header-left" id="dw-popup-header-title">
            Data Warehouse
          </div>
          <a href="close" id="dw-popup-closer" className="ol-popup-closer"> </a>
        </div>
        <div id="dw-popup-content" className="ol-popup-content"></div>
        <div id="dw-popup-tabcontent" className="ol-popup-tabcontent">
          <Tabs defaultActiveKey="info" id="dw-popup-tabs" className="ol-popup-tabcontent">
            <Tab eventKey="info" title="Info" className="ol-tab-contact">
              <div id="dw-popup-tabcontent-info" className="ol-popup-tabcontent-info"></div>
            </Tab>
            <Tab eventKey="contact" title="Contact" className="ol-tab-contact">
              <div id="dw-popup-tabcontent-contact" className="ol-popup-tabcontent-contact"></div>
            </Tab>            
            <Tab eventKey="address" title="Address" className="ol-tab-address">
              <div id="dw-popup-tabcontent-address" className="ol-popup-tabcontent-address"></div>
            </Tab>
          </Tabs>
        </div>
      </div>
      <div id="dw-field-popup" className="ol-popup">
        <div className="ol-popup-header">
          <div className="ol-popup-header-left" id="dw-field-popup-header-title">
            Data Warehouse
          </div>
          <a id="dw-field-popup-prev" className="ol-popup-prev"> </a>
          <span id="dw-field-popup-of" className="ol-popup-of">1 of 1</span>
          <a id="dw-field-popup-next" className="ol-popup-next"> </a>
          <a href="close" id="dw-field-popup-closer" className="ol-popup-closer"> </a>
        </div>
        <div id="dw-field-popup-content" className="ol-popup-content"></div>
      </div>
      <div id="popup" className="ol-popup">
        <div className="ol-popup-header">
          <div className="ol-popup-header-left" id="popup-header-title">
            Available Images
          </div>
          <a href="close" id="popup-closer" className="ol-popup-closer"> </a>
        </div>
        <div id="popup-content" className="ol-popup-content"></div>
      </div>      
      <Modal show={this.state.showModal} onHide={() => this.closeModal()}>
          <Modal.Header closeButton>
              <Modal.Title>Configure {this.state.activeModal}</Modal.Title>
          </Modal.Header>

          <Modal.Body>

            {this.state.activeModal === "Data Warehouse Layer" ? this.mapPropertiesForm() : this.mapServicesForm()}

          </Modal.Body>
          <Modal.Footer>
            <Button className="mt-2" variant="secondary" onClick={() => this.closeModal()}>Close</Button>
            <Button className="mt-2" variant="primary" onClick={() => this.applyLayerConfig(this.state.activeModal)}>Apply</Button>
          </Modal.Footer>
      </Modal>
    </div>);
  }
}

export default DashboardMapWidget;
